import GraphicPromotion from './GraphicPromotion';

export default GraphicPromotion;
